export default __webpack_public_path__ + "static/media/100.c9fd5764.gif";